/**
 * Lets a page extend the top-bar breadcrumb with views that live inside one
 * route (e.g. Connectors › Demo Connector › Edit), where the URL alone can't
 * say where the user is. Layout provides the setter and renders the trail.
 *
 * A trail item is { label } for the current view, or { label, onClick } for a
 * step back. While a page has a trail, Layout turns the section crumb into a
 * link that resets the page, the same way a sidebar click on it does.
 */
import { createContext, useContext, useEffect } from 'react'

export const BreadcrumbContext = createContext(null)

export function usePageBreadcrumbs(trail) {
  const setTrail = useContext(BreadcrumbContext)
  // Re-publish only when the visible labels change, so an item's onClick
  // keeps its first closure: point it at a state setter, not at values.
  const key = trail ? trail.map(item => item.label).join('\u0000') : ''

  // A null trail publishes nothing (rather than clearing), so a page shell
  // and a nested view can each own the trail for the views they render.
  useEffect(() => {
    if (!setTrail || !trail || !trail.length) return undefined
    setTrail(trail)
    return () => setTrail(null)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [setTrail, key])
}
